import React, { Component } from 'react';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import { isMobile } from 'react-device-detect';
import { dominioDemandaCirurgica, dominioNODE } from '../../config/database';
import 'assets/css/rastreio.css';

function dataFormatada(pData) {
  const data = new Date(pData);
  const dia = data.getDate().toString();
  const diaF = dia.length === 1 ? `0${dia}` : dia;
  const mes = (data.getMonth() + 1).toString(); // +1 pois no getMonth Janeiro começa com zero.
  const mesF = mes.length === 1 ? `0${mes}` : mes;
  const anoF = data.getFullYear();
  const hora = data.getHours().toString();
  const horaF = hora.length === 1 ? `0${hora}` : hora;
  const minuto = data.getMinutes().toString();
  const minutoF = minuto.length === 1 ? `0${minuto}` : minuto;
  const segundo = data.getSeconds().toString();
  const segundoF = segundo.length === 1 ? `0${segundo}` : segundo;
  return `${diaF}/${mesF}/${anoF} ${horaF}:${minutoF}:${segundoF}`;
}

class Rastreamento extends Component {
  constructor(props) {
    super(props);
    this.state = {
      codigoPedido: null,
      statusPedido: null,
      corStatusPedido: null,
      paciente: null,
      procedimento: null,
      dataInclusao: null,
      cidPrincipal: null,
      idPedido: null,
      loading: false,
      logPedido: [],
      stepAtual: 2,
      steps: [],
    };
  }

  componentDidMount() {
    const { codigoPedido } = this.props.match.params;
    this.setState({ codigoPedido });

    this.setState({ loading: true });
    dominioDemandaCirurgica.get(`/api/rastreioPedido/${codigoPedido}`).then(
      res => {
        this.setState({
          statusPedido: res.data.statusPedido,
          corStatusPedido: res.data.corStatusPedido,
          paciente: res.data.paciente,
          procedimento: res.data.procedimento,
          dataInclusao: res.data.dataInclusao,
          cidPrincipal: res.data.cidPrincipal,
          idPedido: res.data.idPedido,
          loading: false,
          stepAtual: res.data.stepAtualPedido,
          steps: res.data.listaStatusRastreio,
        });

        dominioNODE.get(`/logpedido/${this.state.idPedido}`).then(res => {
          this.setState({
            logPedido: res.data.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1)),
          });
        });
      },
      () => {
        this.setState({ loading: false });
      }
    );

    dominioDemandaCirurgica.get(`/api/statusPedido`).then(res => {
      this.setState({
        steps: res.data.map(status => status.descricao),
      });
    });
  }

  render() {
    return (
      <>
        <Card>
          <CardHeader color="info">
            <strong>
              {' '}
              Pedido nº
              {this.state.codigoPedido}{' '}
            </strong>
          </CardHeader>
          <CardBody>
            <div className="row-rastreio" id="statusPedido">
              {!isMobile ? (
                <Stepper nonLinear activeStep={this.state.stepAtual}>
                  {this.state.steps.map((label, index) => (
                    <Step key={label}>
                      <StepButton disabled>{label}</StepButton>
                    </Step>
                  ))}
                </Stepper>
              ) : (
                <>
                  <strong> Status atual: </strong>
                  <strong style={{ color: this.state.corStatusPedido }}>
                    {' '}
                    {this.state.statusPedido}
{' '}
                  </strong>
                </>
              )}
            </div>
            <div className="row-rastreio" id="paciente">
              <strong> Paciente: </strong>
              <span> {this.state.paciente} </span>
            </div>
            <div className="row-rastreio" id="procedimento">
              <strong> Procedimento: </strong>
              <span> {this.state.procedimento} </span>
            </div>
            <div className="row-rastreio" id="dataInclusao">
              <strong> Data do Pedido: </strong>
              <span> {this.state.dataInclusao} </span>
            </div>
            <div className="row-rastreio" id="cidPrincipal">
              <strong> CID Principal: </strong>
              <span> {this.state.cidPrincipal} </span>
            </div>
          </CardBody>
        </Card>
        <br />
        <Card>
          <CardHeader color="info">
            <strong> Histórico do pedido </strong>
          </CardHeader>
          <CardBody>
            {this.state.logPedido.map((log, i) => (
              <div className="row-rastreio" id="historico" key={i}>
                <strong> Data: </strong>
                <span> {dataFormatada(log.createdAt)} </span>
                <br />
                <strong> Ação: </strong>
                <span> {log.tipo} </span>
                <br />
                <strong> Descrição: </strong>
                <span> {log.descricao} </span>
              </div>
            ))}
          </CardBody>
        </Card>
      </>
    );
  }
}

export default Rastreamento;
